// extracted by mini-css-extract-plugin
module.exports = {"slideshow":"J_cj","view":"J_cD","slide":"J_cl","img":"J_cF","btn":"J_bR","right":"J_cG","indicators":"J_cH","indicator":"J_cJ","active":"J_cr"};